var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "router-link",
    {
      staticClass: "ig--content-user row row-center",
      attrs: {
        to: _vm.item.openid ? "/user/" + _vm.item.openid : _vm.$route.fullPath,
        tag: "div"
      }
    },
    [
      _c("img", {
        staticClass: "user-avatar",
        attrs: {
          src: _vm.item.iId
            ? _vm.imagePath + "/logo.png"
            : _vm.item.head_url &&
              _vm.mHttps(_vm.decode(_vm.item.head_url.replace(/／/g, "/")))
        }
      }),
      _c("div", { staticClass: "user-file" }, [
        _c("div", { staticClass: "file-up row row-bottom" }, [
          _c("div", {
            staticClass: "file-name",
            style: { color: _vm.mColor(2) },
            domProps: {
              textContent: _vm._s(_vm.item.nick_name || _vm.item.sAuthor)
            }
          })
        ]),
        _c(
          "div",
          {
            staticClass: "file-down file-time",
            style: { color: _vm.mColor(3) }
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm._f("mcFormatTime")(
                    _vm.item.iId ? _vm.item.sIdxTime : _vm.item.addtime * 1000,
                    "M月D日 hh:mm"
                  )
                ) +
                "\n        "
            )
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }